export default __webpack_public_path__ + "static/2-c023258484ba681b0888228a817c8ee6.png";